import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';

export const $DatatableFilters = styled.div`
  padding: 0.5rem;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;

  & > *:first-child {
    flex: 1;
  }
`;

export const $BadgeIconButton = styled.div`
  margin-left: 1rem;
  border-radius: 50%;
  min-width: 1.5rem;
  min-height: 1.5rem;
  background-color: ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.fonts.size.ultraSmall};
  color: ${({ theme }) => theme.colors.white};
  font-weight: ${({ theme }) => theme.fonts.weight.normal};
`;

export const $SwipeableOverflowContainer = styled.div`
  max-height: calc(100vh - 7rem);
  overflow: auto;
  overflow-x: hidden;
  margin: 0 -2rem;
  padding: 0 2rem;

  @media ${media.maxWidth.xs} {
    max-height: calc(100vh - 15rem);
  }
`;

export const $DatatableFiltersFooter = styled.div`
  background-color: ${({ theme }) =>
    theme.colors.datatableRowBackgroundHoverColor};
  min-height: 70px;
  margin: 0 -2rem -2rem;
  padding: 1rem 2rem 0.5rem;
  border-top: 1px solid ${({ theme }) => theme.colors.lightGrey};
`;
